export default {
	api: 'https://ust-testing2.beautitag.com/ldr/api',
	loginTimeout: 86400
};
